import { Link } from "react-router-dom";
import { ArrowUpRight, RefreshCw, XCircle } from "lucide-react";
import PaymentDetailsCard from "../components/payments/PaymentDetailsCard";
import PaymentResultShell from "../components/payments/PaymentResultShell";
import { usePaymentVerification } from "../hooks/usePaymentVerification";

export default function PaymentFailurePage() {
    const { loading, data, error } = usePaymentVerification("failure");

    if (loading) {
        return (
            <PaymentResultShell
                testId="payment-failure-page"
                loading
                loadingText="Checking payment status…"
            />
        );
    }

    return (
        <PaymentResultShell
            testId="payment-failure-page"
            tone="error"
            badge="Transaction incomplete"
            icon={<XCircle className="w-8 h-8 text-rose-400" />}
            title="Payment didn't go through"
            description={
                error ??
                "Your payment could not be completed. No charge was made, or the transaction was declined by your bank or UPI app."
            }
            actions={
                <>
                    <Link
                        to="/pricing"
                        className="inline-flex items-center justify-center gap-2 text-sm font-semibold text-black bg-gradient-to-r from-cyan-300 to-emerald-400 hover:opacity-90 px-6 py-3 rounded-full transition w-full sm:w-auto"
                    >
                        <RefreshCw className="w-4 h-4" />
                        Try again
                    </Link>
                    <Link
                        to="/help"
                        className="inline-flex items-center justify-center gap-2 text-sm font-medium text-zinc-300 hover:text-white border border-white/10 hover:bg-white/5 px-6 py-3 rounded-full transition w-full sm:w-auto"
                    >
                        Contact support
                    </Link>
                </>
            }
        >
            {data && <PaymentDetailsCard data={data} />}
        </PaymentResultShell>
    );
}
